module.exports = __webpack_public_path__ + "static/media/zkj@2x.3abdb7fb.jpg";